import React, { useEffect, useState ,useRef} from "react";
import { useHistory } from "react-router-dom";
import Addmoney from "./addmoney";
import BackgroundTheme from "../../../../Common/P2P/Header/BackgroundTheme";
import { logFirebaseEvent } from "../../firebase";
import { P2P_AMOUNT_SELECTION_VIEW, P2P_INVEST_NOW_BTN } from "../../firebase/constant";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { setAmountValue } from "../dashboardAction";
import { useDispatch, useSelector } from 'react-redux';
const AddmoneyIndex = () => {
  let history = useHistory();
  let dispatch = useDispatch();
  const formikRef:any = useRef();
  const [amount, setAmount] = useState<any>('');
  const [error, setError] = useState<any>(false);
  const [amountError, setAmountError] = useState<boolean>(false);
  useEffect(() => {
    logFirebaseEvent(P2P_AMOUNT_SELECTION_VIEW);
  },[])
  
  useEffect(() => {
    if(amount >= 0){
      setAmountError(false)
    }
  },[amount])

  const confirmInvestment = () => {
    if(amount !== ''){
      setAmountError(false)
      if(amount <= 1000000){
        logFirebaseEvent(P2P_INVEST_NOW_BTN);
        dispatch(setAmountValue(amount))
        history.push({
          pathname:'/p2p/tenure'
        });
      }
    }else{
      setAmountError(true)
    }
  };

  useEffect(()=> {
    document.title = "stashearn - add-money"
  },[])

  const enterKeyPress = (e:any) => {
    if (e.key === 'Enter') {
      if(amount !== null){
        if(!error){
          confirmInvestment();
        }
      }
    }
  }

  return (
    <>
      <BackgroundTheme>
      <Card className='redBorder'>
          <CardContent>
          <Addmoney 
          confirmInvestment={confirmInvestment}
          formikRef={formikRef}
          enterKeyPress={enterKeyPress}
          amount={amount}
          setAmount={setAmount}
          setError={setError}
          error={error}
          amountError={amountError}
          />
         </CardContent>
        </Card>
      </BackgroundTheme>
    </>
  );
};

export default AddmoneyIndex;
